
import { RootState } from '../../../../setup/redux/RootReducer'
import axios, { AxiosResponse } from 'axios'
import {OrderListModel, OrderGroups} from '../models/OrderModels'
import {ResponseHelper} from '../../../../setup/index'

import {API_URL} from '../../../../setup/helpers/apiUrl'
import AuthService from '../../../modules/auth/redux/AuthService'

import {UserModel} from '../../../modules/auth/models/UserModel'

import {Redirect, Route, Switch} from 'react-router-dom'

export const ORDER_PREVIEW_URL = `${API_URL}/api/Order/OrderPreview`
export const ORDER_SEND_URL = `${API_URL}/api/Order/OrderSend`


const usr:UserModel =  AuthService.GetCurrentUser() != null ? JSON.parse(AuthService.GetCurrentUser()) : null ;
console.log("fileSend User =>>", usr);



export default async function SendFileForPreview(file:any){
    
    let resp;
    let OrderList:OrderGroups;
    try{
        const formData = new FormData();
		formData.append('File', file);
        console.log("14 File =>",file);
        await axios.post<ResponseHelper>(ORDER_PREVIEW_URL, formData, {headers:{"Authorization":"bearer " + usr.accessToken}})
        .then((response) =>{
            console.log("then =>", response);
            resp = response;  
        })
        .catch((err) => {
          console.log("thenCatch =>", err);
          if(err.response.Status === 401){
            document.location.reload();
          }
        });
        return resp;
      } 
      catch(err){
        console.log("login error =>", err);
        console.log("catch resp =>", resp);
        return err;
      }
}

export async function sendFile(orderList:OrderListModel[]){
    var resp;
    console.log("OrderSend");
    try{
        await axios.post<ResponseHelper>(ORDER_SEND_URL, orderList,
        {headers:{"content-type":"application/json","Access-Control-Allow-Origin":"*", "Authorization":"bearer " + usr.accessToken}})
        .then((response) =>{
          console.log("then =>", response);
          resp = response; 
        })
        .catch((err) => {
          console.log("thenCatch =>", err);
          if(err.response.Status === 401){
            document.location.reload();
          }
        });
        console.log("Response => ", resp);
        return resp;
      } 
      catch(err){
        console.log("login error =>", err);
        console.log("catch resp =>", resp);
        return err;
      }
}

 